export enum HubspotGlobalEvents {
  FormCallbacks = 'hsFormCallback'
}

export enum HubspotEvents {
  FormReady = 'onFormReady',
  FormSubmit = 'onFormSubmit',
  FormSubmitted = 'onFormSubmitted'
}

export interface CreateFormConfiguration {
  portalId: string;
  formId: string;
  target: string;
}

interface HubspotForms {
  create: (configuration: CreateFormConfiguration) => void;
}

export interface Hubspot
{
  forms: HubspotForms;
}
